export default "__VITE_ASSET__CDI6kKeG__"